import * as React from "react";
import { useTranslation } from 'react-i18next';

const fields =  {

        config: { columns: 1 },
        fields: [
            {
                name: "confirmed",
                label: "formConfig.confirm",
                column: 1,
                type: "radio",
                mandatory: true,
                size: {
                    label: 10,
                    radio: 2
                },
                validate: (value) => {
                    return value === true || value === "true";
                }
            }


        ]

    };


export default fields;